import React from "react"
import logo from "../images/preferenceslogo.png"
import background from "../images/preferencesbg.jpg"

const UnsubscribePage = () => {
    return (
        <div className='flex justify-center items-center min-h-screen' 
    style={{
      backgroundImage: `url(${background})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center"
      }}>
        <div className='bg-white p-5 rounded-sm shadow-lg max-w-[95%] md:max-w-lg w-full'>
            <img src={logo} className='mb-5' alt="Logo"/>
            <h1 className='text-4xl mb-4 text-chestertons-purple'>You&#39;ve been successfully unsubscribed from Chestertons&#39; mailing list</h1>
            <p className="text-sm mb-3">Before you leave, we&#39;d like you to know that you can still stay connected:</p>
            <div className="mb-3">
                <p className="mb-2">Follow us on Social Media</p>
                <a 
                href=""
                target="_blank"
                rel="noopener noreferrer"
                className='bg-chestertons-purple text-white p-2 w-20 rounded-full mb-4 text-center block'>
                Follow
              </a>
            </div>
            <div>
                <p className="mb-2">Visit our website for the latest updates</p>
                <a
                href=""
                target="_blank"
                rel="noopener noreferrer" 
                className='bg-chestertons-purple text-white p-2 w-20 rounded-full text-center block'>
                Visit
              </a>
            </div>
        </div>
     
      </div>
        
    )
}

export default UnsubscribePage;